export function buildDataSelector(
    parentSelector: string | undefined,
    currentSelector: string
): string {
    return parentSelector
        ? `${parentSelector}/${currentSelector}`
        : currentSelector;
}
